"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FuelYourBody() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const horologyBullets = ["Customized strength programming", "Functional movement analysis", "Progressive overload tracking"];
  const furnitureBullets = ["Nutritional strategy planning", "Sustainable lifestyle coaching", "One-on-one performance support"];
  return <section data-section-id="3700" id="fuel-your-body" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-[180px] dark">
      {}
      <div aria-hidden="true" className="hidden lg:block absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-px bg-primary/80 z-10" />

      <div className="grid grid-cols-1 lg:grid-cols-2">
        {}
        <div ref={leftRef} className={`relative bg-background px-6 sm:px-10 lg:pl-16 lg:pr-24 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}

          <div className="relative z-10 max-w-xl">
            

            <h2 className="font-default font-bold uppercase tracking-tight text-foreground text-4xl sm:text-5xl lg:text-[4rem] leading-[0.95] mb-10">
              The science
              <br />
              <span className="text-primary">of movement.</span>
            </h2>

            <p className="font-default text-lg lg:text-xl italic leading-relaxed text-muted-foreground mb-10">
              Coach Kira Fit delivers precision-engineered training programs designed to optimize your physical potential. 
              From foundational strength to advanced athletic conditioning, every session is built on biomechanical 
              integrity and measurable, data-driven progress.
            </p>

            <ul className="space-y-4 mb-12">
              {horologyBullets.map((bullet, i) => <li data-index={i} key={i} className="flex items-start gap-4 font-default text-base lg:text-lg text-foreground">
                  <span className="mt-2.5 h-2 w-2 shrink-0 bg-primary" />
                  <span>{bullet}</span>
                </li>)}
            </ul>

            <Link to="/TheTrainingPathPage" className="inline-block group">
              <Button variant="link" className="font-default font-semibold uppercase tracking-[0.2em] text-sm text-foreground hover:text-primary px-0 h-auto py-2 border-b border-foreground hover:border-primary no-underline">
                View Training
                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>

            {}
            <div className="mt-16 flex justify-end">
              
            </div>
          </div>
        </div>

        {}
        <div className="lg:hidden h-px bg-primary/80 my-16 mx-6" />

        {}
        <div ref={rightRef} className="relative px-6 transition-all duration-1000 ease-out delay-150 translate-y-0 !opacity-[1] sm:px-10 lg:pr-16 lg:pl-24 bg-card/0">
          {}

          <div className="relative z-10 max-w-xl ml-auto">
            

            <h2 className="font-default font-bold uppercase tracking-tight text-foreground text-4xl sm:text-5xl lg:text-[4rem] leading-[0.95] mb-10">
              The balance
              <br />
              <span className="text-primary">of health.</span>
            </h2>

            <p className="font-default text-lg lg:text-xl italic leading-relaxed text-muted-foreground mb-10">
              true fitness extends beyond the gym. Coach Kira provides holistic lifestyle guidance, integrating 
              nutritional habits and recovery protocols to ensure your results are sustainable. We build 
              resilience, confidence, and long-term vitality through consistent, expert-led coaching.
            </p>

            <ul className="space-y-4 mb-12">
              {furnitureBullets.map((bullet, i) => <li data-index={i} key={i} className="flex items-start gap-4 font-default text-base lg:text-lg text-foreground">
                  <span className="mt-2.5 h-2 w-2 shrink-0 bg-primary" />
                  <span>{bullet}</span>
                </li>)}
            </ul>

            <Link to="/StartYourJourneyPage" className="inline-block group">
              <Button variant="link" className="font-default font-semibold uppercase tracking-[0.2em] text-sm text-foreground hover:text-primary px-0 h-auto py-2 border-b border-foreground hover:border-primary no-underline">
                Start Journey
                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>

            {}
            <div className="mt-16 flex justify-start">
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}